import dayjs from "dayjs";

export const STATUSES = [
  "Application Received",
  "Contact Attempted",
  "Interview Scheduled",
  "Selected",
  "Rejected",
  "Not Interested",
  "Future Prospect",
];

export const PIPELINE_STAGES = ["Application Received", "Contact Attempted", "Interview Scheduled", "Selected"];

export const TERMINAL_STATUSES = ["Selected", "Rejected", "Not Interested", "Future Prospect"];

export const formatDate = (iso) => (iso ? dayjs(iso).format("DD MMM YYYY") : "—");
export const formatDateTime = (iso) => (iso ? dayjs(iso).format("DD MMM YYYY, hh:mm A") : "—");

export const formatSalary = (min, max) => {
  const fmt = (v) => {
    if (v == null) return null;
    if (v >= 100000) return `₹${(v / 100000).toFixed(v % 100000 === 0 ? 0 : 1)} LPA`;
    return `₹${(v / 1000).toFixed(0)}K`;
  };
  const a = fmt(min);
  const b = fmt(max);
  if (a && b) return `${a} – ${b}`;
  return a || b || "Not disclosed";
};

export const MASTER_TYPES = [
  // Client Management
  { key: "company_status", label: "Company Status", category: "Client Management" },
  { key: "company_type", label: "Company Types", category: "Client Management" },
  { key: "industry", label: "Industries", category: "Client Management" },
  { key: "office_type", label: "Office Types", category: "Client Management" },
  { key: "communication_method", label: "Communication Methods", category: "Client Management" },
  { key: "contact_type", label: "Contact Types", category: "Client Management" },
  { key: "document_type", label: "Document Types", category: "Client Management" },
  { key: "billing_model", label: "Billing Models", category: "Client Management" },
  { key: "payment_terms", label: "Payment Terms", category: "Client Management" },
  { key: "locking_period_template", label: "Locking Period Templates", category: "Client Management" },
  // Recruitment
  { key: "interview_mode", label: "Interview Modes", category: "Recruitment" },
  { key: "qualification", label: "Qualifications", category: "Recruitment" },
  { key: "course", label: "Courses", category: "Recruitment" },
  { key: "specialization", label: "Specializations", category: "Recruitment" },
  { key: "passing_year", label: "Passing Years", category: "Recruitment" },
  { key: "experience", label: "Experience", category: "Recruitment" },
  { key: "language", label: "Languages", category: "Recruitment" },
  { key: "skill", label: "Skills", category: "Recruitment" },
  { key: "certification", label: "Certifications", category: "Recruitment" },
  { key: "preferred_location", label: "Preferred Locations", category: "Recruitment" },
  { key: "notice_period", label: "Notice Periods", category: "Recruitment" },
  { key: "available_to_join", label: "Available to Join", category: "Recruitment" },
  { key: "employment_status", label: "Employment Status", category: "Recruitment" },
  { key: "job_role", label: "Job Role Categories", category: "Recruitment" },
  { key: "department", label: "Departments", category: "Recruitment" },
  { key: "gender", label: "Gender Options", category: "Recruitment" },
  { key: "disposition", label: "Recruiter Dispositions", category: "Recruitment" },
  { key: "communication_rating", label: "Communication Ratings", category: "Recruitment" },
  { key: "source", label: "Sources", category: "Recruitment" },
  // Location
  { key: "country", label: "Countries", category: "Location" },
  { key: "state", label: "States", category: "Location" },
  { key: "city", label: "Cities", category: "Location" },
  // Work Configuration
  { key: "working_days", label: "Working Days", category: "Work Configuration" },
  { key: "shift", label: "Shift Types", category: "Work Configuration" },
  { key: "work_mode", label: "Work Modes", category: "Work Configuration" },
  // Applications (M03 Application Engine)
  { key: "application_stage", label: "Application Stages", category: "Applications" },
  { key: "application_status", label: "Application Statuses", category: "Applications" },
  { key: "application_priority", label: "Application Priorities", category: "Applications" },
  { key: "application_reason", label: "Application Reasons", category: "Applications" },
  { key: "employment_record_status", label: "Employment Record Statuses", category: "Applications" },
  // Jobs (legacy website groups)
  { key: "hiring_brand", label: "Hiring Brands", category: "Jobs & Website" },
  { key: "location", label: "Job Locations", category: "Jobs & Website" },
  { key: "education", label: "Education (Jobs)", category: "Jobs & Website" },
  { key: "employment_type", label: "Employment Types", category: "Jobs & Website" },
  { key: "status", label: "Statuses", category: "Jobs & Website" },
];

export const MASTER_CATEGORIES = ["Client Management", "Recruitment", "Applications", "Location", "Work Configuration", "Jobs & Website"];

// Groups whose items carry an admin-managed category (M03+)
export const CATEGORIZED_MASTER_GROUPS = {
  application_stage: ["Active", "Terminal"],
  application_reason: ["Candidate Related", "Eligibility Related", "Interview Related", "Company Related", "Internal"],
};

export const JOB_STATUSES = ["Draft", "Active", "Paused", "Closed", "Archived"];
export const JOB_STATUS_ACTIVE = "Active";

export const waLink = (number) => `https://wa.me/${(number || "").replace(/\D/g, "")}`;
